import { Box, FormLabel, Input, Text, Image, VStack } from "@chakra-ui/react";
import { useRef, useState, useEffect } from "react";

const InputAndDragAndDrop = ({ title, name, url, setFiles, setFieldValue, setFieldTouched }) => {
  const [preview, setPreview] = useState(url || null);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (url && typeof url === 'string') {
      setPreview(url);
    }
  }, [url]);

  useEffect(() => {
  return () => {
    if (preview?.startsWith("blob:")) {
      URL.revokeObjectURL(preview);
    }
  };
}, [preview]);

  // const handleFileChange = (e) => {
  //   const file = e.target.files?.[0];
    
  //   if (!file) {
  //     console.log(`No file selected for ${name}`);
  //     return;
  //   }
    
  //   setFileName(file.name);
    
  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreview(reader.result);
  //     if (setFieldValue) {
  //       setFieldValue(name, file);
  //     }
  //     if (setFieldTouched) {
  //       setFieldTouched(name, true);
  //     }
  //   };
  //   reader.onerror = (error) => {
  //     console.error(`Error reading file for ${name}:`, error);
  //   };
  //   reader.readAsDataURL(file);
    
  //   if (setFiles) {
  //     setFiles((prevFiles) => {
  //       const newFiles = {
  //         ...prevFiles,
  //         [name]: file 
  //       };
  //       console.log(`✓ Stored file in state for ${name}:`, file instanceof File);
  //       return newFiles;
  //     });
  //   } else {
  //     console.error(`⚠️ setFiles not provided for ${name}`);
  //   }
  // };

  const handleFileChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  // preview
  const objectUrl = URL.createObjectURL(file);
  setPreview(objectUrl);
  setFileName(file.name);

  // Formik
  setFieldValue(name, file);
  setFieldTouched(name, true);

  // Files state (IMPORTANT)
  if (setFiles) {
    setFiles(prev => ({
      ...prev,
      [name]: file,
    }));
  }
};

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const file = e.dataTransfer.files?.[0]; 
    
    if (!file) {
      console.log(`No file dropped for ${name}`);
      return;
    }
    
    const syntheticEvent = {
      target: {
        files: [file]
      }
    };
    handleFileChange(syntheticEvent);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box w="100%">
      <FormLabel fontSize="1rem" color="#1A202C" htmlFor={name}>
        {title}
      </FormLabel>
      
      <Input
        ref={fileInputRef}
        type="file"
        name={name}
        id={name}
        accept="image/*"
        onChange={handleFileChange}
        display="none"
      />
      
      <Box
        border="2px dashed"
        borderColor="gray.300"
        borderRadius="lg"
        p={4}
        textAlign="center"
        cursor="pointer"
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        _hover={{ borderColor: "blue.400", bg: "gray.50" }}
        bg={preview ? "gray.50" : "white"}
        transition="all 0.2s"
      >
        {preview ? (
          <VStack spacing={2}>
            <Image
              src={preview}
              alt={title}
              maxH="200px"
              objectFit="contain"
            />
            <Text fontSize="sm" color="gray.600" fontWeight="medium">
              {fileName || "Uploaded"}
            </Text>
            <Text fontSize="xs" color="gray.500">
              Click to change
            </Text>
          </VStack>
        ) : (
          <VStack spacing={2}>
            <Text fontSize="sm" color="gray.500">
              Drag and drop or click to upload
            </Text>
            <Text fontSize="xs" color="gray.400">
              Supported formats: JPG, PNG
            </Text>
          </VStack>
        )}
      </Box>
    </Box>
  );
};

export default InputAndDragAndDrop;